import { TENANT_CODE } from 'libs/constants';
import { getPackageApiBaseUrl } from 'libs/env';
import { getIdToken } from 'libs/liff-api';
import { ApiClient } from './api-client';

/**
 * ユーザーがスマートレシートに連携済みかどうかを問い合わせる
 *
 * @return {Promise<boolean>} 連携済みの場合はtrue、未連携の場合はfalse
 * @throws {import('libs/features-api').NetworkError} FetchAPIが失敗した場合
 * @throws {import('libs/features-api').ResponseError} APIの問い合わせ結果が「失敗」の場合
 */
export const callMemberPointCardInquiry = async (): Promise<boolean> => {
  const client = new ApiClient({
    packageHost: getPackageApiBaseUrl(),
    tenantCode: TENANT_CODE,
    liffIdToken: getIdToken({ throwable: true })
  });

  return await client.callMemberPointCardInquiry();
};
